/* LOOV: buy box (Standard + Direct), LOOV Circle consent, membership guard, quick add, sheets.
   See snippets/loov-consent.liquid, snippets/loov-pdp-mode.liquid and sections/loov-product.liquid.

   Membership rules (both experiences):
   - Member price = the product's "VIP Price" variant. A LOOV Circle membership = that variant
     carrying a selling plan that Revley is configured for (the data-revley-selling-plan-ids list on
     Revley's script tag). The plan is never hard-coded: it is resolved per product from the plans
     the VIP variant offers, intersected with Revley's list.
   - One membership per cart: the first member item carries the plan; later member items ride on
     it (or merge into it when they are the same piece). Revley treats every plan line as its own
     recurring item, so a second plan line would mean a second recurring charge.
   - Guard: if member-price items added by these pages are in the cart but no line carries the
     plan (e.g. the plan line was removed), the plan is put back on one of them, so member prices
     are never sold without the membership.
   - Direct pages take consent in the cart: when a LOOV membership line (one added by these
     pages, marked _loov_pdp) has no consent recorded on it, checkout is blocked until the
     LOOV Circle box in the cart drawer is ticked (recorded as the _loov_circle_consent cart
     attribute). Lines added by other templates are left as they were. */
(function () {
  if (window.__loovDS) return;
  window.__loovDS = true;

  var C = window.LoovDS || {};
  var ROOT = C.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_URL = C.cartUrl || ROOT + 'cart';
  var LEGACY_PLAN = Number(C.sellingPlanId || 0);
  var realFetch = window.fetch.bind(window);

  /* ---------- helpers ---------- */
  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function log() { try { console.info.apply(console, ['[LOOV]'].concat([].slice.call(arguments))); } catch (e) {} }

  function fetchCart() {
    return realFetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function postJSON(path, body) {
    return realFetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not update the cart.');
        return data;
      });
    });
  }
  function hasMembership(cart) {
    var items = (cart && cart.items) || [];
    return items.some(function (it) { return !!it.selling_plan_allocation; });
  }
  function addItems(items) {
    // Goes through window.fetch on purpose, so the cart drawer and analytics see the add.
    return window.fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
        return data;
      });
    });
  }
  function openDrawer() {
    var drawer = document.querySelector('sugar-cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') { window.location.href = CART_URL; return Promise.resolve(); }
    return realFetch(CART_URL + '?sections=sugar-cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); })
      .then(function (sections) { drawer.renderContents({ id: null, sections: sections }); })
      .catch(function () { window.location.href = CART_URL; });
  }
  function consentRecord(terms) {
    return 'Agreed ' + new Date().toISOString() + ' on ' + window.location.pathname + ': ' + (terms || '');
  }
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'lv-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }
  function busy(btn, on) { if (btn) btn.setAttribute('aria-busy', on ? 'true' : 'false'); }
  function money(cents) { return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, ''); }

  /* ---------- LOOV Circle plan resolution (Revley) ---------- */
  function gidNum(v) { var s = String(v == null ? '' : v).trim().split('/').pop(); return /^\d+$/.test(s) ? s : ''; }
  // Plans Revley is set up for, read from Revley's own script tag. null = Revley isn't on the page.
  function revleyPlans() {
    var el = document.querySelector('script[data-revley-selling-plan-ids]');
    if (!el) return null;
    try {
      var list = JSON.parse(el.getAttribute('data-revley-selling-plan-ids') || '[]');
      return (Array.isArray(list) ? list : []).map(gidNum).filter(Boolean);
    } catch (e) { return []; }
  }
  // productPlans: plan ids the VIP variant offers (from the page). Returns { plan } or { reason }.
  function resolvePlan(productPlans) {
    var rv = revleyPlans();
    if (rv === null) return { plan: 0, reason: 'revley_missing' };
    if (!rv.length) return { plan: 0, reason: 'revley_has_no_plans' };
    if (!productPlans.length) return { plan: 0, reason: 'no_selling_plan' };
    for (var i = 0; i < productPlans.length; i++) if (rv.indexOf(productPlans[i]) > -1) return { plan: Number(productPlans[i]) };
    return { plan: 0, reason: 'plan_not_in_revley' };
  }
  function linePlan(item) { return item && item.selling_plan_allocation ? gidNum(item.selling_plan_allocation.selling_plan.id) : ''; }
  function sameProps(a, b) {
    a = a || {}; b = b || {};
    var ka = Object.keys(a).filter(function (k) { return a[k] !== null && a[k] !== ''; }).sort();
    var kb = Object.keys(b).filter(function (k) { return b[k] !== null && b[k] !== ''; }).sort();
    if (ka.join('|') !== kb.join('|')) return false;
    return ka.every(function (k) { return String(a[k]) === String(b[k]); });
  }
  var CONFIG_MESSAGES = {
    no_vip_variant: 'the product has no "VIP Price" variant',
    no_selling_plan: 'the "VIP Price" variant has no selling plan (LOOV Circle) attached',
    revley_missing: 'the Revley checkout script is not on this page',
    revley_has_no_plans: 'Revley has no selling plans configured (data-revley-selling-plan-ids is empty)',
    plan_not_in_revley: 'the VIP variant’s selling plan is not one Revley is configured for',
    plan_dropped: 'Shopify did not attach the selling plan to the cart line, so it was removed again'
  };

  /* ---------- attribution (first and last touch, kept on the cart) ---------- */
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'ttclid'];
  function touchFromUrl() {
    var q; try { q = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var parts = [];
    ATTR_KEYS.forEach(function (k) { var v = q.get(k); if (v) parts.push(k + '=' + v.slice(0, 120)); });
    if (!parts.length) return null;
    return parts.join('&') + ' | ' + window.location.pathname + ' | ' + new Date().toISOString().slice(0, 16);
  }
  (function captureTouch() {
    var t = touchFromUrl();
    if (!t) return;
    try {
      if (!localStorage.getItem('lv_first_touch')) localStorage.setItem('lv_first_touch', t);
      localStorage.setItem('lv_last_touch', t);
    } catch (e) {}
  })();
  function syncAttribution(cart) {
    var first = '', last = '';
    try { first = localStorage.getItem('lv_first_touch') || ''; last = localStorage.getItem('lv_last_touch') || ''; } catch (e) {}
    var attrs = (cart && cart.attributes) || {};
    var upd = {};
    if (first && !attrs._loov_first_touch) upd._loov_first_touch = first;
    if (last && attrs._loov_last_touch !== last) upd._loov_last_touch = last;
    if (!Object.keys(upd).length) return Promise.resolve();
    return postJSON('cart/update.js', { attributes: upd }).catch(function () {});
  }

  /* ---------- sheets ---------- */
  var lastFocus = null;
  function openSheet(id, opener) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    lastFocus = opener || document.activeElement;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = $('.lv-sheet__panel', sheet);
    setTimeout(function () { if (panel) panel.focus(); }, 30);
  }
  function closeSheet(sheet) {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (!$('.lv-sheet.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lv-sheet-open]');
    if (opener) { e.preventDefault(); e.stopPropagation(); openSheet(opener.getAttribute('data-lv-sheet-open'), opener); return; }
    var closer = e.target.closest('[data-lv-sheet-close]');
    if (closer) { e.preventDefault(); closeSheet(closer.closest('.lv-sheet')); }
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-lv-scroll-buy]');
    if (!a) return;
    var buy = document.querySelector('[data-lv-buy]');
    if (!buy) return;
    e.preventDefault();
    buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var open = $$('.lv-sheet.is-open').pop(); if (open) closeSheet(open); }
  });

  /* ---------- consent block (standard product page and quick add) ---------- */
  function Consent(el) {
    this.el = el;
    this.box = $('[data-lv-consent-box]', el);
    this.terms = $('[data-terms]', el);
    var self = this;
    if (this.box) this.box.addEventListener('change', function () { if (self.box.checked) self.el.classList.remove('has-error'); });
  }
  Consent.prototype.setMember = function (on) { this.el.classList.toggle('is-member', !!on); };
  Consent.prototype.ok = function () { return !!(this.box && this.box.checked); };
  Consent.prototype.fail = function () {
    this.el.classList.add('has-error');
    this.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (this.box) this.box.focus({ preventScroll: true });
  };

  /* Standard: adds a member-priced item: plan + consent for a new membership, plain VIP variant if
     the cart already has one. Resolves false if consent is still needed. */
  function addMember(vipId, qty, consent, plan, extra) {
    return fetchCart().then(function (cart) {
      var member = hasMembership(cart);
      consent.setMember(member);
      if (!member && !consent.ok()) { consent.fail(); return false; }
      var item = { id: Number(vipId), quantity: Number(qty), properties: Object.assign({}, extra || {}) };
      if (!member && plan) {
        item.selling_plan = plan;
        item.properties._loov_circle_consent = consentRecord(consent.terms && consent.terms.getAttribute('data-terms'));
      }
      if (!Object.keys(item.properties).length) delete item.properties;
      return addItems([item]).then(function () { consent.setMember(true); return fetchCart(); })
        .then(function (after) { return syncAttribution(after); })
        .then(function () { return true; });
    });
  }
  function addOnce(variantId, qty, extra) {
    var item = { id: Number(variantId), quantity: Number(qty) };
    if (extra) item.properties = extra;
    return addItems([item]).then(function () { return fetchCart(); }).then(syncAttribution);
  }

  /* Direct: member price only. Attaches the LOOV Circle plan unless the cart already has a
     membership (then it rides on it, or merges into it when it's the same piece), checks Shopify
     actually kept the plan, and removes the item again if it didn't. */
  function addDirect(vipId, qty, plan, expectedCents) {
    var vid = Number(vipId);
    var props = { _loov_pdp: 'direct' };
    return fetchCart().then(function (cart) {
      var items = cart.items || [];
      var planLine = null;
      for (var i = 0; i < items.length; i++) if (items[i].selling_plan_allocation) { planLine = items[i]; break; }
      var attach = !planLine || (planLine.variant_id === vid && linePlan(planLine) === String(plan) && sameProps(planLine.properties, props));
      var item = { id: vid, quantity: Number(qty), properties: props };
      if (attach) item.selling_plan = plan;
      var before = 0;
      items.forEach(function (l) { if (l.variant_id === vid && sameProps(l.properties, props) && (attach ? linePlan(l) === String(plan) : !l.selling_plan_allocation)) before = l.quantity; });
      return addItems([item]).then(function (res) {
        var added = (res.items || [])[0] || {};
        if (attach && linePlan(added) !== String(plan)) {
          var keep = Math.max(0, Number(added.quantity || qty) - Number(qty));
          return postJSON('cart/change.js', { id: added.key, quantity: keep }).catch(function () {}).then(function () {
            var err = new Error('config'); err.reason = 'plan_dropped'; throw err;
          });
        }
        return fetchCart().then(function (after) {
          // The bundle price shown on the page should be what the cart charges for a fresh line.
          var line = (after.items || []).filter(function (l) { return l.key === added.key; })[0];
          if (line && before === 0 && expectedCents && line.final_line_price !== Number(expectedCents)) {
            console.warn('[LOOV Direct] Price check: the page showed ' + money(expectedCents) + ' but the cart charges ' + money(line.final_line_price) + ' for ' + line.quantity + ' × ' + line.product_title + '. Check the bundle discount on the product page matches the automatic discount in Shopify.');
          }
          return syncAttribution(after);
        });
      });
    });
  }

  /* ---------- product page buy box ---------- */
  function initBuy(root) {
    if (root.__lv) return; root.__lv = true;
    var mode = root.getAttribute('data-mode') === 'direct' ? 'direct' : 'standard';
    var vip = root.getAttribute('data-vip');
    var guest = root.getAttribute('data-guest');
    var plans = (root.getAttribute('data-plans') || '').split(',').map(gidNum).filter(Boolean);
    var resolved = resolvePlan(plans);
    var consentEl = $('[data-lv-consent]', root);
    var consent = consentEl ? new Consent(consentEl) : null;
    var atc = $('[data-lv-atc]', root);
    var atcLabel = $('[data-lv-atc-label]', root);
    var guestBtn = $('[data-lv-guest]', root);
    var guestPrice = $('[data-lv-guest-price]', root);
    var status = $('[data-lv-status]', root);
    var sticky = document.querySelector('[data-lv-sticky="' + root.id + '"]');
    var stickySub = sticky && $('[data-lv-sticky-sub]', sticky);
    var stickyAtc = sticky && $('[data-lv-sticky-atc]', sticky);
    var stickyLabel = sticky && $('[data-lv-sticky-label]', sticky);
    var stockEl = $('[data-lv-stock]', root);
    var stock = null;
    try { stock = JSON.parse(root.getAttribute('data-stock') || 'null'); } catch (e) { stock = null; }
    var soldOut = root.getAttribute('data-sold-out') || 'Sold out';
    root.setAttribute('data-plan', resolved.plan || '');

    function current() {
      var input = $('input[name="lv-bundle"]:checked', root) || $('input[name="lv-bundle"]', root);
      return input ? {
        qty: Number(input.getAttribute('data-qty') || 1),
        label: input.getAttribute('data-label') || '',
        member: input.getAttribute('data-member-total') || '',
        cents: Number(input.getAttribute('data-member-cents') || 0),
        was: input.getAttribute('data-member-was') || '',
        guest: input.getAttribute('data-guest-total') || ''
      } : { qty: 1, label: '', member: root.getAttribute('data-member-price'), cents: Number(root.getAttribute('data-member-cents') || 0), was: '', guest: root.getAttribute('data-guest-price') };
    }
    /* Stock: the "In stock" line, Add to cart, the sticky bar and "buy once" follow live Shopify
       inventory for the variant being bought and the bundle size (rules: snippets/loov-stock). */
    function stockOf(v, qty) {
      if (!v || !v.available) return { state: 'out', left: 0 };
      if (v.tracked && v.deny) {
        if (v.left <= 0) return { state: 'out', left: 0 };
        if (v.left < qty) return { state: 'short', left: v.left };
        if (v.left <= Number(stock.low || 10)) return { state: 'low', left: v.left };
      }
      return { state: 'in', left: v.left };
    }
    function stockText(st) {
      var d = stockEl ? stockEl.dataset : {};
      if (st.state === 'out') return d.out || 'Sold out.';
      if (st.state === 'in') return d.in || 'In stock.';
      return String(d.low || 'Only [inventory] left.').replace(/\[inventory\]/g, st.left);
    }
    function bare(t) { return String(t).replace(/\.\s*$/, ''); }
    function applyStock(c) {
      var blocked = !!root.getAttribute('data-config-error');
      var main = stock ? stockOf(stock.vip, c.qty) : { state: 'in', left: 0 };
      var text = stockText(main);
      $$('[data-lv-stock-dot]', root).concat(sticky ? $$('[data-lv-stock-dot]', sticky) : []).forEach(function (dot) {
        dot.classList.toggle('is-low', main.state === 'low' || main.state === 'short');
        dot.classList.toggle('is-out', main.state === 'out');
      });
      $$('[data-lv-stock-eta]', root).concat(sticky ? $$('[data-lv-stock-eta]', sticky) : []).forEach(function (el) { el.hidden = main.state === 'out'; });
      if (stockEl) { stockEl.setAttribute('data-state', main.state); var head = $('[data-lv-stock-head]', stockEl); if (head) head.textContent = text; }
      var stickyStock = sticky && $('[data-lv-sticky-stock]', sticky);
      if (stickyStock) stickyStock.textContent = bare(text);
      var off = blocked || main.state === 'out' || main.state === 'short';
      [atc, stickyAtc].forEach(function (b) { if (b) { b.disabled = off; if (off) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); } });
      if (atcLabel && !blocked) {
        atcLabel.textContent = main.state === 'out' ? soldOut : main.state === 'short' ? bare(text) : (atcLabel.getAttribute('data-prefix') || 'Add to cart') + ' · ' + c.member;
      }
      if (stickyLabel && !blocked) stickyLabel.textContent = main.state === 'out' ? soldOut : 'Add to cart';
      if (guestBtn) {
        var g = stock ? stockOf(stock.guest, c.qty) : { state: 'in' };
        var gOff = g.state === 'out' || g.state === 'short';
        guestBtn.disabled = gOff;
        if (guestPrice) guestPrice.textContent = gOff ? (g.state === 'out' ? soldOut : bare(stockText(g))) : c.guest;
      }
    }
    // Inventory can change while the page is open: re-read it from Shopify when the shopper comes back.
    var stockReadAt = Date.now();
    function refreshStock() {
      if (!stock || Date.now() - stockReadAt < 60000) return;
      stockReadAt = Date.now();
      var section = root.id.replace(/^LvBuy-/, '');
      var view = new URLSearchParams(window.location.search).get('view');
      realFetch(window.location.pathname + '?section_id=' + encodeURIComponent(section) + (view ? '&view=' + encodeURIComponent(view) : ''), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('section'); return r.text(); })
        .then(function (html) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lv-buy][data-stock]');
          if (!el) return;
          stock = JSON.parse(el.getAttribute('data-stock'));
          render();
        }).catch(function () {});
    }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshStock(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { stockReadAt = 0; refreshStock(); } });

    function render() {
      var c = current();
      applyStock(c);
      if (stickySub) {
        stickySub.innerHTML = '';
        var b = document.createElement('b'); b.textContent = c.member;
        stickySub.appendChild(document.createTextNode(c.label ? c.label + ' · ' : ''));
        stickySub.appendChild(b);
        if (c.was) { var s = document.createElement('s'); s.textContent = c.was; stickySub.appendChild(document.createTextNode(' ')); stickySub.appendChild(s); }
      }
    }
    $$('input[name="lv-bundle"]', root).forEach(function (i) { i.addEventListener('change', render); });
    render();

    function say(msg) { if (status) status.textContent = msg || ''; }

    /* Configuration errors block the Direct flow: never sell one-time from a Direct page. */
    function configError(reason) {
      var msg = CONFIG_MESSAGES[reason] || reason;
      root.setAttribute('data-config-error', reason);
      [atc, stickyAtc].forEach(function (b) { if (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); } });
      if (atcLabel) atcLabel.textContent = 'Not available on this page';
      if (stickyLabel) stickyLabel.textContent = 'Not available';
      console.error('[LOOV Direct] Configuration error on "' + root.getAttribute('data-product') + '": ' + msg + '. The Direct add to cart is disabled until this is fixed.');
      if (status) {
        status.innerHTML = '';
        status.appendChild(document.createTextNode('This piece can’t be bought on this page right now. '));
        var a = document.createElement('a'); a.href = (window.location.pathname.replace(/^.*\/products\//, ROOT + 'products/')); a.textContent = 'Shop it here'; status.appendChild(a);
        status.appendChild(document.createTextNode('.'));
        var debug = (window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'))) || /lv_debug/.test(window.location.search);
        if (debug) { var d = document.createElement('span'); d.className = 'lv-status__debug'; d.textContent = ' Setup check: ' + msg + '.'; status.appendChild(d); }
      }
    }

    if (mode === 'direct') {
      var serverError = root.getAttribute('data-config-error');
      if (serverError) configError(serverError);
      else if (!resolved.plan) configError(resolved.reason);
      var directAdd = function (btn) {
        if (root.getAttribute('data-config-error')) return;
        say('');
        busy(btn, true);
        var c = current();
        addDirect(vip, c.qty, resolved.plan, c.cents).then(function () {
          busy(btn, false);
          return openDrawer();
        }).catch(function (err) {
          busy(btn, false);
          if (err && err.reason) configError(err.reason); else say(err.message);
        });
      };
      if (atc) atc.addEventListener('click', function (e) { e.preventDefault(); directAdd(atc); });
      if (stickyAtc) stickyAtc.addEventListener('click', function (e) { e.preventDefault(); directAdd(stickyAtc); });
    } else {
      var plan = resolved.plan || Number((revleyPlans() || [])[0] || 0) || LEGACY_PLAN;
      var memberAdd = function (btn) {
        say('');
        if (!vip) return;
        busy(btn, true);
        var c = current();
        addMember(vip, c.qty, consent, plan, { _loov_pdp: 'standard' }).then(function (added) {
          busy(btn, false);
          if (added) return openDrawer();
        }).catch(function (err) { busy(btn, false); say(err.message); });
      };
      if (atc) atc.addEventListener('click', function (e) { e.preventDefault(); memberAdd(atc); });
      if (stickyAtc) stickyAtc.addEventListener('click', function (e) { e.preventDefault(); memberAdd(stickyAtc); });
      if (guestBtn) guestBtn.addEventListener('click', function (e) {
        e.preventDefault();
        say('');
        busy(guestBtn, true);
        addOnce(guest, current().qty, { _loov_pdp: 'standard' }).then(function () { busy(guestBtn, false); return openDrawer(); })
          .catch(function (err) { busy(guestBtn, false); say(err.message); });
      });
      if (consent) {
        consent.setMember(root.getAttribute('data-member-cart') === 'true');
        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'visible') fetchCart().then(function (c) { consent.setMember(hasMembership(c)); }).catch(function () {});
        });
      }
    }

    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(atc);
    }
  }

  /* ---------- cart: membership guard + LOOV Circle consent before checkout ---------- */
  var cartState = null;      // last /cart.js seen
  var refreshing = null;     // in-flight refresh promise
  function isVipLine(l) { return l && l.variant_title === 'VIP Price'; }
  function lineConsent(cart) {
    return ((cart && cart.items) || []).some(function (l) { return l.selling_plan_allocation && l.properties && l.properties._loov_circle_consent; });
  }
  function consentGiven(cart) {
    if (!cart) return false;
    if (cart.attributes && cart.attributes._loov_circle_consent) return true;
    return lineConsent(cart);
  }
  // A membership line added by a LOOV product page (Direct, or re-attached by the guard).
  function loovPlanLine(l) { return !!(l && l.selling_plan_allocation && l.properties && l.properties._loov_pdp); }
  function consentCardWanted(cart) { return !!cart && (cart.items || []).some(loovPlanLine) && !lineConsent(cart); }
  function needsConsent(cart) { return consentCardWanted(cart) && !consentGiven(cart); }

  // Member prices without the membership: put the plan back on a member line added by a LOOV
  // product page (marked _loov_pdp). Lines added by other templates are left untouched.
  function ensureMembership(cart) {
    var items = (cart && cart.items) || [];
    if (hasMembership(cart)) return Promise.resolve(cart);
    var vipLine = items.filter(function (l) { return isVipLine(l) && l.properties && l.properties._loov_pdp; })[0];
    if (!vipLine) return Promise.resolve(cart);
    var candidates = (revleyPlans() || []).slice();
    if (!candidates.length && LEGACY_PLAN) candidates.push(String(LEGACY_PLAN));
    function tryPlan(i) {
      if (i >= candidates.length) {
        console.error('[LOOV] Member-price item "' + vipLine.product_title + '" has no LOOV Circle membership in the cart and none of Revley’s plans could be attached.');
        return Promise.resolve(cart);
      }
      return postJSON('cart/change.js', { id: vipLine.key, quantity: vipLine.quantity, selling_plan: Number(candidates[i]) })
        .then(function (c) {
          if (hasMembership(c)) { log('Re-attached the LOOV Circle plan to', vipLine.product_title); return c; }
          return tryPlan(i + 1);
        }, function () { return tryPlan(i + 1); });
    }
    return tryPlan(0).then(function (c) {
      if (c !== cart) {
        // Let the cart drawer re-render with the corrected line.
        /* global publish, PUB_SUB_EVENTS */
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'loov-membership-guard', cartData: c }); } catch (e) {}
      }
      return c;
    });
  }

  function consentTerms() {
    var tpl = document.getElementById('lv-cart-consent-tpl');
    return tpl ? (tpl.getAttribute('data-terms') || '') : '';
  }
  function placeConsent(cart) {
    var footer = document.querySelector('sugar-cart-drawer .sugar-cart-drawer__footer');
    var checkout = footer && footer.querySelector('.sugar-cart-checkout');
    var card = document.querySelector('[data-lv-cart-consent]');
    if (!consentCardWanted(cart) || !checkout) { if (card) card.remove(); return; }
    if (!card) {
      var tpl = document.getElementById('lv-cart-consent-tpl');
      if (!tpl) return;
      card = tpl.content.firstElementChild.cloneNode(true);
      var box = card.querySelector('[data-lv-cart-consent-box]');
      box.addEventListener('change', function () {
        card.classList.remove('has-error');
        var value = box.checked ? consentRecord(consentTerms()) : '';
        box.disabled = true;
        postJSON('cart/update.js', { attributes: { _loov_circle_consent: value } })
          .then(function (c) { cartState = c; })
          .catch(function () { box.checked = !box.checked; toast('Something went wrong. Please try again.'); })
          .then(function () { box.disabled = false; });
      });
    }
    if (card.nextElementSibling !== checkout || card.parentNode !== checkout.parentNode) checkout.parentNode.insertBefore(card, checkout);
    var cb = card.querySelector('[data-lv-cart-consent-box]');
    if (cb && !cb.disabled) cb.checked = consentGiven(cart);
  }

  // Consent belongs to the membership in the cart: once no membership is left, forget it, so a
  // membership added later asks again.
  function dropStaleConsent(cart) {
    if (!cart || hasMembership(cart) || !(cart.attributes && cart.attributes._loov_circle_consent)) return Promise.resolve(cart);
    return postJSON('cart/update.js', { attributes: { _loov_circle_consent: '' } }).catch(function () { return cart; });
  }
  var refreshAgain = false;
  function refreshCart() {
    // A cart change while a refresh is running gets its own pass afterwards.
    if (refreshing) { refreshAgain = true; return refreshing; }
    refreshing = fetchCart().then(ensureMembership).then(dropStaleConsent).then(function (cart) {
      cartState = cart; placeConsent(cart); return cart;
    }).catch(function () { return cartState; }).then(function (c) {
      refreshing = null;
      if (refreshAgain) { refreshAgain = false; return refreshCart(); }
      return c;
    });
    return refreshing;
  }
  var refreshTimer = null;
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshCart, 150); }

  // Watch cart writes from anything on the page (drawer quantity buttons, upsells, add to cart):
  // through fetch, and through resource timing as a backstop for other request types.
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  (function () {
    var f = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      var p = f.apply(window, arguments);
      if (CART_WRITE.test(String(url))) p.then(scheduleRefresh, scheduleRefresh);
      return p;
    };
  })();
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        if (list.getEntries().some(function (e) { return CART_WRITE.test(e.name); })) scheduleRefresh();
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }
  // Re-place the card whenever the drawer re-renders.
  function watchDrawer() {
    var drawer = document.querySelector('sugar-cart-drawer');
    if (!drawer || drawer.__lvWatch) return;
    drawer.__lvWatch = true;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { if (cartState) placeConsent(cartState); else refreshCart(); }, 60);
    }).observe(drawer, { childList: true, subtree: true });
  }

  // Checkout gate. Runs on window in the capture phase, before the cart drawer and Revley.
  var bypass = false;
  function checkoutTarget(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    if (e.type === 'submit') {
      var f = t;
      if (e.submitter && e.submitter.name === 'checkout') return f;
      if (f.querySelector && f.querySelector('[name="checkout"]')) return f;
      var action = (f.getAttribute && f.getAttribute('action')) || '';
      return /\/checkout(s)?(\/|\?|$)/.test(action) ? f : null;
    }
    var el = t.closest('[name="checkout"], a[href*="/checkout"]');
    return el;
  }
  function blockForConsent(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var card = document.querySelector('[data-lv-cart-consent]');
    if (!card) { openDrawer().then(function () { setTimeout(function () { placeConsent(cartState); failCard(); }, 300); }); return; }
    failCard();
  }
  function failCard() {
    var card = document.querySelector('[data-lv-cart-consent]');
    if (!card) return;
    card.classList.add('has-error');
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var box = card.querySelector('[data-lv-cart-consent-box]');
    if (box) box.focus({ preventScroll: true });
  }
  function gate(e) {
    if (bypass || e.defaultPrevented) return;
    if (e.type === 'click' && (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return;
    var target = checkoutTarget(e);
    if (!target) return;
    if (cartState && !refreshing) {
      if (needsConsent(cartState)) blockForConsent(e);
      return;
    }
    // Cart state unknown or changing: hold the click, check, then let it through untouched.
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter || null;
    refreshCart().then(function (cart) {
      if (needsConsent(cart)) { failCard(); if (!document.querySelector('[data-lv-cart-consent]')) openDrawer(); return; }
      bypass = true;
      try {
        if (e.type === 'submit' && typeof target.requestSubmit === 'function') target.requestSubmit(submitter && submitter.form === target ? submitter : undefined);
        else if (typeof target.click === 'function') target.click();
      } finally { bypass = false; }
    });
  }
  window.addEventListener('click', gate, true);
  window.addEventListener('submit', gate, true);

  /* ---------- gallery ---------- */
  function initGallery(g) {
    if (g.__lv) return; g.__lv = true;
    var track = $('[data-lv-track]', g);
    var thumbs = $$('[data-lv-thumb]', g);
    var count = $('[data-lv-count]', g);
    if (!track) return;
    var slides = $$('.lv-gallery__slide', track);
    function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function mark() {
      var i = idx();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    var raf = null;
    track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; mark(); }); }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); }); });
    mark();
  }

  /* ---------- quick add ---------- */
  var quickReady = false;
  function initQuick() {
    if (quickReady) return; quickReady = true;
    var sheet = document.getElementById('lv-quick-sheet');
    var q = { vip: null, guest: null };
    var consent = sheet ? new Consent($('[data-lv-consent]', sheet)) : null;
    function fill(btn) {
      $('[data-lv-q-img]', sheet).src = btn.getAttribute('data-image') || '';
      $('[data-lv-q-img]', sheet).alt = btn.getAttribute('data-title') || '';
      $('[data-lv-q-title]', sheet).textContent = btn.getAttribute('data-title') || '';
      $('[data-lv-q-price]', sheet).textContent = btn.getAttribute('data-member-price') || '';
      $('[data-lv-q-was]', sheet).textContent = btn.getAttribute('data-guest-price') || '';
      $('[data-lv-q-guest-price]', sheet).textContent = btn.getAttribute('data-guest-price') || '';
      $('[data-lv-q-atc-price]', sheet).textContent = btn.getAttribute('data-member-price') || '';
      $('[data-lv-q-link]', sheet).href = btn.getAttribute('data-url') || '#';
      $('[data-lv-q-status]', sheet).textContent = '';
      q.vip = btn.getAttribute('data-vip');
      q.guest = btn.getAttribute('data-guest');
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lv-quick]');
      if (!btn) return;
      e.preventDefault();
      var simple = btn.getAttribute('data-simple');
      if (simple || !sheet) {
        busy(btn, true);
        addOnce(simple || btn.getAttribute('data-guest'), 1).then(function () { busy(btn, false); return openDrawer(); })
          .catch(function (err) { busy(btn, false); toast(err.message); });
        return;
      }
      fill(btn);
      fetchCart().then(function (c) { consent.setMember(hasMembership(c)); }).catch(function () {});
      openSheet('lv-quick-sheet', btn);
    });
    if (!sheet) return;
    var atc = $('[data-lv-q-atc]', sheet);
    var guestBtn = $('[data-lv-q-guest]', sheet);
    var status = $('[data-lv-q-status]', sheet);
    var quickPlan = Number((revleyPlans() || [])[0] || 0) || LEGACY_PLAN;
    atc.addEventListener('click', function (e) {
      e.preventDefault();
      busy(atc, true);
      addMember(q.vip, 1, consent, quickPlan).then(function (added) {
        busy(atc, false);
        if (added) { closeSheet(sheet); return openDrawer(); }
      }).catch(function (err) { busy(atc, false); status.textContent = err.message; });
    });
    guestBtn.addEventListener('click', function (e) {
      e.preventDefault();
      busy(guestBtn, true);
      addOnce(q.guest, 1).then(function () { busy(guestBtn, false); closeSheet(sheet); return openDrawer(); })
        .catch(function (err) { busy(guestBtn, false); status.textContent = err.message; });
    });
  }

  /* ---------- review filters ---------- */
  function initFilters(wrap) {
    if (wrap.__lv) return; wrap.__lv = true;
    var chips = $$('[data-lv-filter]', wrap);
    var reviews = $$('[data-tags]', wrap);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var tag = chip.getAttribute('data-lv-filter');
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        reviews.forEach(function (r) { r.hidden = !(tag === 'all' || (r.getAttribute('data-tags') || '').split('|').indexOf(tag) !== -1); });
        var sc = $('.lv-scroller', wrap); if (sc) sc.scrollTo({ left: 0 });
      });
    });
  }

  /* ---------- scroller dots ---------- */
  function initDots(dots) {
    if (dots.__lv) return; dots.__lv = true;
    var sc = document.getElementById(dots.getAttribute('data-lv-dots'));
    if (!sc) return;
    var spans = $$('span', dots);
    function mark() {
      var max = sc.scrollWidth - sc.clientWidth;
      var i = max <= 0 ? 0 : Math.round((sc.scrollLeft / max) * (spans.length - 1));
      spans.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    }
    sc.addEventListener('scroll', mark, { passive: true });
    mark();
  }

  /* ---------- delivery estimate ---------- */
  function initArrive(el) {
    var min = Number(el.getAttribute('data-min') || 6), max = Number(el.getAttribute('data-max') || 9);
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + min); b.setDate(b.getDate() + max);
    var m = function (d) { return d.toLocaleString('en-US', { month: 'short' }); };
    el.textContent = m(a) === m(b) ? m(a) + ' ' + a.getDate() + '–' + b.getDate() : m(a) + ' ' + a.getDate() + '–' + m(b) + ' ' + b.getDate();
  }

  function init() {
    $$('[data-lv-buy]').forEach(initBuy);
    $$('[data-lv-gallery]').forEach(initGallery);
    $$('[data-lv-filters]').forEach(initFilters);
    $$('[data-lv-dots]').forEach(initDots);
    $$('[data-lv-arrive]').forEach(initArrive);
    initQuick();
    watchDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  refreshCart();

  window.LoovDS = Object.assign(window.LoovDS || {}, { resolvePlan: resolvePlan, revleyPlans: revleyPlans, refreshCart: refreshCart });
})();
